<template>
    <div class="">
        <div v-if="this.$route.name == 'ConsultaCierreMensual'">
            <div class="col-md-12 mt-3">
                <h2> {{ labels.title }} </h2>
            </div>
            <div class="row mt-5">
                <div class="col-md-6 d-flex justify-content-end">
                    <h4>{{ labels.fechaCierre }}</h4>
                </div>
                <div class="col-md-2 d-flex justify-content-start">
                    <!-- <input type="month" v-model="fechaCierre" class="form-control"> -->
                    <select v-model="fechaCierre" class="form-control">
                        <option value="">{{ labels.seleccion }}</option>
                        <option v-for="item in lstFechaCierre" :key="item.id" :value="item.fecha_cierre"> {{ item.fecha_cierre }} </option>
                    </select>
                </div>
            </div>
            <div class="col-md-12 mt-4">
                <b-button type="button" id="create-btn" @click="procesarCierre">{{ labels.consultar }}</b-button>
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaExcelCierreMensual()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="dataCierreMensual != 0">
                <b-table
                    :items="listCierreMensual"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #cell(nro_contrato)="data">
                        <div class="text-right">{{ data.item.nro_contrato }}</div>
                    </template>
                    <template #cell(tasa)="data">
                        <div class="text-right">{{ formatDecimal(data.item.tasa) }}</div>
                    </template>
                    <template #cell(valor_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_canon) }}</div>
                    </template>
                    <template #cell(total_valor_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.total_valor_canon) }}</div>
                    </template>
                    <template #cell(pasivo_inicial)="data">
                        <div class="text-right">{{ formatNumber(data.item.pasivo_inicial) }}</div>
                    </template>
                    <template #cell(total_cambio_pasivo)="data">
                        <div class="text-right">{{ formatNumber(data.item.total_cambio_pasivo) }}</div>
                    </template>
                    <template #cell(total_pago_capital)="data">
                        <div class="text-right">{{ formatNumber(data.item.total_pago_capital) }}</div>
                    </template>
                    <template #cell(total_intereses)="data">
                        <div class="text-right">{{ formatNumber(data.item.total_intereses) }}</div>
                    </template>
                    <template #cell(pasivo_final)="data">
                        <div class="text-right">{{ formatNumber(data.item.pasivo_final) }}</div>
                    </template>
                    <template #cell(activo_derecho_uso_bruto)="data">
                        <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso_bruto) }}</div>
                    </template>
                    <template #cell(total_gasto_amortizacion)="data">
                        <div class="text-right">{{ formatNumber(data.item.total_gasto_amortizacion) }}</div>
                    </template>
                    <template #cell(tipo_tasa)="data">
                        <div class="text-left">{{ nombreTipoTasa(data.item.tipo_tasa) }}</div>
                    </template>
                    <template #cell(puntos_adicionales)="data">
                        <div class="text-right">{{ formatDecimal(data.item.puntos_adicionales) }}</div>
                    </template>
                    <template #cell(frecuencia)="data">
                        <div class="text-right">{{ formatNumber(data.item.frecuencia) }}</div>
                    </template>
                    <template #cell(modalidad)="data">
                        <div class="text-left">{{ nombreModalidad(data.item.modalidad) }}</div>
                    </template>
                    <template #cell(tasa_cambio_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.tasa_cambio_canon) }}</div>
                    </template>
                    <template #cell(puntos_adicionales_cambio_canon)="data">
                        <div class="text-right">{{ formatDecimal(data.item.puntos_adicionales_cambio_canon) }}</div>
                    </template>
                    <template #cell(periodicidad_cambio_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.periodicidad_cambio_canon) }}</div>
                    </template>
                    <template #cell(estado)="data">
                        <div class="text-left">{{ data.item.estado }}</div>
                    </template>
                </b-table>
                <div class="row col-12 mt-1">
                    <div class="col-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="dataCierreMensual.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="this.$route.name == 'ConsultaCierreMensual'">
                    <h5>{{ labels.noRow }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "exceljs";
import ContratoCierre from '../../services/ContratoCierre';
import TipoTasas from "../../services/TipoTasas";

export default {
    name : 'CierreMensual',
    props : ['listCierreMensual'],
    data: () => ({
        fechaCierre : '',
        lstFechaCierre : [],
        listCierreMensual : [],
        dataCierreMensual : [],
        btnGenExcel : false,
        lstTipoTasas : [],
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'fecha_cierre', label: 'Fecha cierre', sortable: false },
            { key: 'tasa', label: 'Tasa', sortable: false },
            { key: 'valor_canon', label: 'Valor canon', sortable: false },
            { key: 'total_valor_canon', label: 'Total valor canon', sortable: false },
            { key: 'pasivo_inicial', label: 'Pasivo inicial', sortable: false },
            { key: 'total_cambio_pasivo', label: 'Total cambio pasivo', sortable: false },
            { key: 'total_pago_capital', label: 'Total pago capital', sortable: false },
            { key: 'total_intereses', label: 'Total intereses', sortable: false },
            { key: 'pasivo_final', label: 'Pasivo final', sortable: false },
            { key: 'activo_derecho_uso_bruto', label: 'Activo derecho de uso bruto', sortable: false },
            { key: 'total_gasto_amortizacion', label: 'Total gasto amortización', sortable: false },
            { key: 'tipo_tasa', label: 'Tipo tasa', sortable: false },
            { key: 'puntos_adicionales', label: 'Puntos adicionales', sortable: false },
            { key: 'frecuencia', label: 'Frecuencia', sortable: false },
            { key: 'modalidad', label: 'Modalidad', sortable: false },
            { key: 'tasa_cambio_canon', label: 'Tasa cambio canon', sortable: false },
            { key: 'puntos_adicionales_cambio_canon', label: 'Puntos adicionales cambio canon', sortable: false },
            { key: 'periodicidad_cambio_canon', label: 'Periodicidad cambio canon', sortable: false },
            { key: 'estado', label: 'Estado', sortable: false }
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Consulta cierre mensual',
                    fechaCierre : 'Fecha cierre:',
                    fecha : 'Fecha cierre',
                    consultar : 'Consultar',
                    nroContrato : 'Nro. contrato',
                    tasa : 'Tasa',
                    valorCanon : 'Valor canon',
                    totalValorCanon : 'Total valor canon',
                    pasivoInicial : 'Pasivo inicial',
                    totalCambioPasivo : 'Total cambio pasivo',
                    totalPagoCapital : 'Total pago capital',
                    totalIntereses : 'Total intereses',
                    pasivoFinal : 'Pasivo final',
                    activoDerechoUsoBruto : 'Activo derecho de uso bruto',
                    totalGastoAmortizacion : 'Total gasto amortización',
                    tipoTasa : 'Tipo tasa',
                    puntosAdicionales : 'Puntos adicionales',
                    frecuencia : 'Frecuencia',
                    modalidad : 'Modalidad',
                    tasaCambioCanon : 'Tasa cambio canon',
                    puntosAdicionalesCambioCanon : 'Pts adicionales cambio canon',
                    periodicidadCambioCanon : 'Periodicidad cambio canon',
                    noRow : 'No hay registros',
                    seleccion : 'Seleccione...',
                }
            }else{
                return {
                    title : 'Monthly closing consultation',
                    fechaCierre : 'Closing date:',
                    fecha : 'Closing date',
                    consultar : 'Consult',
                    nroContrato : 'Contract Num.',
                    tasa : 'Rate',
                    valorCanon : 'Canon value',
                    totalValorCanon : 'Total canon value',
                    pasivoInicial : 'Initial liabilities',
                    totalCambioPasivo : 'Total passive change',
                    totalPagoCapital : 'Total capital payment',
                    totalIntereses : 'Total interests',
                    pasivoFinal : 'Final passive',
                    activoDerechoUsoBruto : 'Gross active right of use',
                    totalGastoAmortizacion : 'Total amortization expense',
                    tipoTasa : 'Rate type',
                    puntosAdicionales : 'Additional points',
                    frecuencia : 'Frequency',
                    modalidad : 'Modality',
                    tasaCambioCanon : 'Canon exchange rate',
                    puntosAdicionalesCambioCanon : 'Additional pts change canon',
                    periodicidadCambioCanon : 'Fee change frequency',
                    noRow : 'There are no records',
                    seleccion : 'Select...',
                }
            }
        }
    },
    methods:{
        procesarCierre(){
            if(this.fechaCierre != ''){

                ContratoCierre.getContratoCierreByFecha(this.fechaCierre)
                .then((res) => {
                    // console.log(res.data);
                    this.listCierreMensual = res.data.listContratosCerrados
                    this.dataCierreMensual = this.listCierreMensual

                    if(this.listCierreMensual.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                    }
                })
                .catch((err) => console.log(err))

            }else{
                this.$toast.error('Diligenciar la fecha.')
            }
        },
        async generaExcelCierreMensual(){
            
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Cierre mensual "+this.fechaCierre)

            const titulo = ["Cierre mensual "+this.fechaCierre]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:T1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const tituloCelda = [
                'Nro. contrato',
                'Fecha cierre',
                'Tasas',
                'Valor canon',
                'Total valor canon',
                'Pasivo inicial',
                'Total cambio pasivo',
                'Total pago capital',
                'Total intereses',
                'Pasivo final',
                'Activo derecho de uso bruto',
                'Total gasto amortización',
                'Tipo tasa',
                'Puntos adicionales',
                'Frecuencia',
                'Modalidad',
                'Tasa cambio canon',
                'Puntos adicionales cambio canon',
                'Periodicidad cambio canon',
                'Estado',
            ]
            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.listCierreMensual.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.fecha_cierre,
                    this.formatDecimal(e.tasa),
                    this.formatNumber(e.valor_canon),
                    this.formatNumber(e.total_valor_canon),
                    this.formatNumber(e.pasivo_inicial),
                    this.formatNumber(e.total_cambio_pasivo),
                    this.formatNumber(e.total_pago_capital),
                    this.formatNumber(e.total_intereses),
                    this.formatNumber(e.pasivo_final),
                    this.formatNumber(e.activo_derecho_uso_bruto),
                    this.formatNumber(e.total_gasto_amortizacion),
                    this.nombreTipoTasa(e.tipo_tasa),
                    this.formatDecimal(e.puntos_adicionales),
                    this.formatNumber(e.frecuencia),
                    e.modalidad == 'V' ? 'Vencida' : 'Anticipada',
                    isNaN(this.formatNumber(e.tasa_cambio_canon)) ? 0 : this.formatNumber(e.tasa_cambio_canon),
                    isNaN(this.formatNumber(e.puntos_adicionales_cambio_canon)) ? 0 : this.formatDecimal(e.puntos_adicionales_cambio_canon),
                    isNaN(this.formatNumber(e.periodicidad_cambio_canon)) ? 0 : this.formatNumber(e.periodicidad_cambio_canon),
                    e.estado,
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Cierre mensual "+this.fechaCierre+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        },
        nombreTipoTasa(nroTipoTasa){
            const tipoTasa = this.lstTipoTasa.find(t => t.tipo_tasa === nroTipoTasa)
            return tipoTasa ? tipoTasa.descripcion : null
        },
        nombreModalidad(m){            
            if(m == 'V'){
                return 'Vencida'
            
            }else if(m == 'A'){
                return 'Anticipada'
            
            }else if(m == 'F'){
                return 'Fija'
            }
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        formatDecimal(value){
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(value);
        },
    },
    mounted(){
        
        ContratoCierre.getListadoFechas()
        .then((res) => {
            // console.log(res.data.lstFechaCierre);
            this.lstFechaCierre = res.data.lstFechaCierre
        })
        .catch((err) => console.log(err))

        TipoTasas.getAllTipoTasas()
        .then((res) => {
            this.lstTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => { console.log(err) })
    },
    watch:{
        fechaCierre(val){
            if(val == ""){
                this.dataCierreMensual = []
                this.btnGenExcel = false
            }
        }
    }
}
</script>

<style>

</style>
